import { jsxs as s, jsx as r } from "react/jsx-runtime";
import a from "../../Icons/User.js";
import { useLoginContext as g } from "../context.js";
import { Wrapper as l, Text as p, UserIconWrapper as c } from "./styled.js";
const h = () => {
  const { loginUrl: e, linkTarget: n = "_self", authManager: o, setIsLoggedIn: t } = g();
  return /* @__PURE__ */ s(l, { href: e, target: n, onClick: async (i) => {
    i.preventDefault(), await o.signInUser(), t(!0);
  }, children: [
    /* @__PURE__ */ r(p, { children: "Log in" }),
    /* @__PURE__ */ r(c, { children: /* @__PURE__ */ r(a, {}) })
  ] });
};
export {
  h as default
};
